/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import DigioFlowContainer from "./DigioFlow.container";

export default DigioFlowContainer;
